exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2Eu1H7vxPJ2Vmlrz2lknUx{font-weight:600;font-size:21px}html[dir] ._2Eu1H7vxPJ2Vmlrz2lknUx{margin-bottom:26px}html[dir=ltr] ._2Eu1H7vxPJ2Vmlrz2lknUx{margin-left:16px}html[dir=rtl] ._2Eu1H7vxPJ2Vmlrz2lknUx{margin-right:16px}._3tkPBRJgvEkN0_PuTiEsZJ{position:relative;height:100%}", ""]);

// exports
exports.locals = {
	"header": "_2Eu1H7vxPJ2Vmlrz2lknUx",
	"conflictsContainer": "_3tkPBRJgvEkN0_PuTiEsZJ"
};